if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // 1. SILUETA MEDALLERO
        const selectedSilueta = document.querySelector('input[name="properties[Silueta Elegida]"]:checked');
        if (selectedSilueta) {
          formData.set('properties[Silueta Elegida]', selectedSilueta.value);
        }

        // 2. CUERO Y CUERDA TRAVELBOOK
        const selectedCuero = document.querySelector('input[name="properties[Color del Cuero]"]:checked');
        if (selectedCuero) formData.set('properties[Color del Cuero]', selectedCuero.value);

        const selectedCuerda = document.querySelector('input[name="properties[Color de la Cuerda]"]:checked');
        if (selectedCuerda) formData.set('properties[Color de la Cuerda]', selectedCuerda.value);

        const selectedOjal = document.querySelector('input[name="properties[Color del Ojal]"]:checked');
        if (selectedOjal && !selectedOjal.disabled) formData.set('properties[Color del Ojal]', selectedOjal.value);

        // 3. GRABADO MEDALLERO (Texto)
        const ludikToggleMedallero = document.getElementById('ludik-enable-name');
        const ludikInputMedallero = document.getElementById('ludik-name-raw');
        const MEDALLERO_ENGRAVING_ID = '57050280460628';

        if (ludikToggleMedallero && ludikToggleMedallero.checked) {
          const rawText = ludikInputMedallero.value.trim().toUpperCase();
          if (!rawText) {
            alert('Por favor, escribe el texto para el grabado.');
            ludikInputMedallero.focus();
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('loading');
            if (this.querySelector('.loading__spinner')) this.querySelector('.loading__spinner').classList.add('hidden');
            return;
          }
          formData.set('properties[Texto Grabado]', rawText);
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(MEDALLERO_ENGRAVING_ID, 10), quantity: 1, properties: { 'Texto Grabado': rawText } }] })
          });
        }

        // 4. GRABADO TRAVELBOOK (Iniciales Golpe Seco)
        const ludikToggleTravel = document.getElementById('ludik-enable-engraving');
        const ludikInputTravel = document.getElementById('ludik-engraving-raw');
        const TRAVEL_ENGRAVING_ID = '57053854662996';

        if (ludikToggleTravel && ludikToggleTravel.checked) {
          const initials = ludikInputTravel.value.replace(/[^a-zA-Z]/g, '').toUpperCase();
          if (!initials) {
            alert('Por favor, introduce al menos una inicial para el grabado.');
            ludikInputTravel.focus();
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('loading');
            if (this.querySelector('.loading__spinner')) this.querySelector('.loading__spinner').classList.add('hidden');
            return;
          }
          const formattedInitials = initials.split('').join('.') + '.';
          formData.set('properties[Iniciales Grabadas]', formattedInitials);
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(TRAVEL_ENGRAVING_ID, 10), quantity: 1, properties: { 'Iniciales Grabadas': formattedInitials } }] })
          });
        }

        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
